import {
  Utensils,
  Coffee,
  Wine,
  Beer,
  Cake,
  IceCream,
  Pizza,
  Calendar,
  CalendarHeart,
  PartyPopper,
  Ticket,
  Music,
  Mic,
  Map,
  MapPin,
  Bike,
  Waves,
  Sailboat,
  Anchor,
  Fish,
  Palmtree,
  Sun,
  Sparkles,
  Heart,
  Flower2,
  Dumbbell,
  Tent,
  Tag,
  Gift,
  Star,
  Camera,
  Plane,
  Car,
  Bus,
  Bed,
  Hotel,
  ShoppingBag,
  Baby,
  Dog,
  Trees,
  type LucideIcon,
} from 'lucide-react';

/**
 * Catalog of icons that can be assigned to a product from the admin.
 *
 * `sfSymbol` is the value stored in the database and rendered by the iOS app
 * (via SwiftUI's `Image(systemName:)`). The admin displays the matching
 * `lucide` component as a visual preview next to the label.
 */
export interface ProductIcon {
  sfSymbol: string;
  label: string;
  lucide: LucideIcon;
}

export const PRODUCT_ICONS: ProductIcon[] = [
  // Food & drink
  { sfSymbol: 'fork.knife', label: 'Restaurant / Table', lucide: Utensils },
  { sfSymbol: 'cup.and.saucer.fill', label: 'Coffee / Café', lucide: Coffee },
  { sfSymbol: 'wineglass.fill', label: 'Wine / Bar', lucide: Wine },
  { sfSymbol: 'mug.fill', label: 'Beer / Drinks', lucide: Beer },
  { sfSymbol: 'birthday.cake.fill', label: 'Cake / Dessert', lucide: Cake },
  { sfSymbol: 'snowflake', label: 'Ice cream', lucide: IceCream },
  { sfSymbol: 'fork.knife.circle.fill', label: 'Pizza / Fast food', lucide: Pizza },

  // Events & tickets
  { sfSymbol: 'calendar', label: 'Event', lucide: Calendar },
  { sfSymbol: 'calendar.badge.plus', label: 'Special event', lucide: CalendarHeart },
  { sfSymbol: 'party.popper.fill', label: 'Party', lucide: PartyPopper },
  { sfSymbol: 'ticket.fill', label: 'Ticket / Pass', lucide: Ticket },
  { sfSymbol: 'music.note', label: 'Concert / Music', lucide: Music },
  { sfSymbol: 'mic.fill', label: 'Live show', lucide: Mic },

  // Tours, outdoors, beach
  { sfSymbol: 'map.fill', label: 'Tour', lucide: Map },
  { sfSymbol: 'mappin.and.ellipse', label: 'Location experience', lucide: MapPin },
  { sfSymbol: 'bicycle', label: 'Bike rental / Tour', lucide: Bike },
  { sfSymbol: 'water.waves', label: 'Beach / Watersports', lucide: Waves },
  { sfSymbol: 'sailboat.fill', label: 'Sailing / Boat', lucide: Sailboat },
  { sfSymbol: 'anchor', label: 'Marina', lucide: Anchor },
  { sfSymbol: 'fish.fill', label: 'Fishing', lucide: Fish },
  { sfSymbol: 'leaf.fill', label: 'Tropical / Beach club', lucide: Palmtree },
  { sfSymbol: 'sun.max.fill', label: 'Day pass', lucide: Sun },

  // Wellness & lifestyle
  { sfSymbol: 'sparkles', label: 'Spa / Beauty', lucide: Sparkles },
  { sfSymbol: 'heart.fill', label: 'Wellness', lucide: Heart },
  { sfSymbol: 'leaf.circle.fill', label: 'Yoga / Meditation', lucide: Flower2 },
  { sfSymbol: 'figure.strengthtraining.traditional', label: 'Gym / Fitness', lucide: Dumbbell },
  { sfSymbol: 'tent.fill', label: 'Camping / Glamping', lucide: Tent },

  // Misc
  { sfSymbol: 'tag.fill', label: 'Generic offer', lucide: Tag },
  { sfSymbol: 'gift.fill', label: 'Gift / Package', lucide: Gift },
  { sfSymbol: 'star.fill', label: 'Featured / Premium', lucide: Star },
  { sfSymbol: 'camera.fill', label: 'Photo session', lucide: Camera },
  { sfSymbol: 'airplane', label: 'Transfer / Flight', lucide: Plane },
  { sfSymbol: 'car.fill', label: 'Car / Transport', lucide: Car },
  { sfSymbol: 'bus.fill', label: 'Bus / Shuttle', lucide: Bus },
  { sfSymbol: 'bed.double.fill', label: 'Room / Bed', lucide: Bed },
  { sfSymbol: 'building.2.fill', label: 'Hotel / Resort', lucide: Hotel },
  { sfSymbol: 'bag.fill', label: 'Shopping', lucide: ShoppingBag },
  { sfSymbol: 'figure.and.child.holdinghands', label: 'Kids / Family', lucide: Baby },
  { sfSymbol: 'pawprint.fill', label: 'Pet friendly', lucide: Dog },
  { sfSymbol: 'tree.fill', label: 'Nature / Park', lucide: Trees },
];

export const findProductIcon = (sfSymbol?: string | null): ProductIcon | undefined => {
  if (!sfSymbol) return undefined;
  return PRODUCT_ICONS.find((i) => i.sfSymbol === sfSymbol);
};
